<template>
  <div class="video-fram">
    <div>
      <wh-popup-select v-model="deviceId" :columns="camerList" @change="getCameraDetails" />
    </div>
    <iframe v-if="deviceId" :src="cameraUrl" width="100%" style="height:100%" />
    <div v-else class="no-camera">
      暂无摄像头
    </div>
  </div>
</template>

<script>
import api from '@/api'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect.vue'
export default {
  components: { WhPopupSelect },
  props: {
    userId: {
      type: Number,
      default: undefined
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      camerList: [],
      deviceId: '',
      cameraUrl: '',
      cameraDetails: {}
    }
  },
  watch: {
    userId: {
      handler(newV) {
        if (newV) {
          this.getCameraListNoLogin(newV)
        }
      },
      immediate: true
    }
  },
  methods: {
    async getCameraListNoLogin(userId) {
      await api.getCameraListNoLogin({ userId }).then(res => {
        res.data.list.map(i => {
          this.camerList.push({
            text: i.cameraName,
            value: i.id
          })
          this.deviceId = this.camerList[0].value
          this.getCameraDetails()
        })
      }).catch()
    },
    getCameraDetails() {
      const params = {
        userId: this.userId,
        id: this.deviceId
      }
      api.getCameraDetailsNoLogin(params).then(({ data }) => {
        this.cameraDetails = data.cameraInfo
        this.cameraUrl = `https://open.ys7.com/ezopen/h5/iframe?url=ezopen://${this.cameraDetails.validateCode}@open.ys7.com/${this.cameraDetails.deviceSerial}/1.live&autoplay=1&templete=0&accessToken=${this.cameraDetails.accessToken}`
        this.$emit('update:visible', true)
      }).catch((e) => {
        console.error(e)
        this.$emit('update:visible', false)
      })
    }

  }
}
</script>

<style lang="less" scoped>
.video-fram{
  margin-bottom: 20px;
  height: calc(100vw * 0.6);
  width: 100%;
}
.no-camera{
  width: 100%;
  height: calc(100vw * 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
}
</style>
